import axios from "axios";

const baseURL = process.env.REACT_APP_BASE_API_URL;

export const createSetupIntent = async ({
  donorDetails,
  paymentMethodType,
  intervalDescription
}) => {
  const response = await axios.post(`${baseURL}/payments/create-setup-intent`, {
    donorDetails,
    paymentMethodType,
    intervalDescription
  });
  return response.data;
};

export const scheduleDonations = async (payload) => {
  try {
    const response = await axios.post(
      `${baseURL}/payments/schedule-donations`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error scheduling donations:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const getRamadanConfig = async () => {
  const response = await axios.get(`${baseURL}/autodonation/ramadan/config`);
  return response.data;
};

export const getSchedule = async (scheduleId) => {
  try {
    const response = await axios.get(
      `${baseURL}/payments/schedule?id=${scheduleId}`
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching schedule:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const cancelSchedule = async (scheduleId) => {
  try {
    const response = await axios.post(
      `${baseURL}/payments/cancel-schedule/${scheduleId}`
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error cancelling schedule:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const createPaymentIntent = async (payload) => {
  try {
    const response = await axios.post(
      `${baseURL}/payments/create-payment-intent`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error creating payment intent:",
      error.response?.data || error.message
    );
    throw error;
  }
};
